import { render } from "./PopupError.vue?vue&type=template&id=22564fec&scoped=true"
import script from "./PopupError.vue?vue&type=script&lang=js"
export * from "./PopupError.vue?vue&type=script&lang=js"

import "./PopupError.vue?vue&type=style&index=0&id=22564fec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22564fec"]])

export default __exports__